import { Code, CodeBlock, Heading, PanelSection, Paragraph } from '@customerio/pluma-components/react';
import { identifySnippet, installSnippet, SnippetKind, trackSnippet } from '../snippets';

type SnippetStepsProps = {
  siteId: string;
  assetHost: string;
  identify: Parameters<typeof identifySnippet>[0];
  onCopy: (kind: SnippetKind) => void;
};

/** The three-step install guide, built for one credential. */
export function SnippetSteps({ siteId, assetHost, identify, onCopy }: SnippetStepsProps) {
  return (
    <PanelSection withBorder>
      <Heading level="3" color="bold" mb="100">
        Step 1: Add the basic snippet
      </Heading>

      <Paragraph mb="200">
        You should include this snippet on every page in your app, immediately before the closing{' '}
        <Code>&lt;/body&gt;</Code> tag.
      </Paragraph>

      <CodeBlock
        language="html"
        code={installSnippet(siteId, assetHost)}
        onCopyButtonClick={() => onCopy(SnippetKind.Install)}
      />

      <Heading mt="300" level="3" color="bold" mb="100">
        Step 2 (optional): Identify your users
      </Heading>

      <Paragraph mb="200">
        To segment users and send emails, you need to identify your users to us. This should be below the snippet in
        your html.
      </Paragraph>

      <CodeBlock
        language="html"
        code={identifySnippet(identify)}
        onCopyButtonClick={() => onCopy(SnippetKind.Identify)}
      />

      <Heading mt="300" level="3" color="bold" mb="100">
        Step 3 (optional): Track events
      </Heading>

      <Paragraph mb="200">
        In addition to attributes, you may want to track custom events like <Code>purchased</Code> or{' '}
        <Code>watchedIntroVideo</Code>.
      </Paragraph>

      <Paragraph mb="200">Here&apos;s an example:</Paragraph>

      <CodeBlock language="html" code={trackSnippet()} onCopyButtonClick={() => onCopy(SnippetKind.Track)} />
    </PanelSection>
  );
}
